<ng-container [formGroup]="form.formGroup">
  <mat-toolbar color="primary"><strong>{{ form.formGroup.value.label }}</strong></mat-toolbar>
  <app-frat-questions-array [formControlName]="form.formControlNames.questions"></app-frat-questions-array>
</ng-container>
